import RedirectToLoginPage from '@/services/auth/redirectService/RedirectToLoginPage';
import RedirectAfterAccessTokenExpiration from '@/services/auth/redirectService/RedirectAfterAccessTokenExpiration';

export default class AuthRedirectService {
    /**
     * Redirect to the refresh page or the logout page after an access token expiration.
     *
     * @returns {void}
     */
    static redirectAfterAccessTokenExpiration() {
        (new RedirectAfterAccessTokenExpiration()).handle();
    }

    /**
     * Redirect to the login page and reset all auth settings before.
     *
     * @param {String} redirectRouteName
     *
     * @returns {void}
     */
    static redirectToLoginPage(redirectRouteName = 'login') {
        (new RedirectToLoginPage()).handle(redirectRouteName);
    }
}
